import React from 'react';
import { Button } from '../ui/Button';

interface IPIntroScreenProps {
  hasInProgress: boolean;
  onStart: () => void;
  onStartOver: () => void;
}

export const IPIntroScreen: React.FC<IPIntroScreenProps> = ({
  hasInProgress,
  onStart,
  onStartOver,
}) => {
  return (
    <div className="flex-1 flex flex-col items-center justify-center text-center px-4 py-8 animate-fade-up opacity-0">
      <h1
        className="font-serif text-3xl sm:text-4xl leading-tight mb-4"
        style={{ color: 'hsl(var(--foreground))' }}
      >
        Find your investing archetype
      </h1>
      <p
        className="text-base leading-relaxed max-w-sm mb-3"
        style={{ color: 'hsl(var(--muted-foreground))' }}
      >
        Answer 18 short questions and see how you match against nine legendary investors,
        from Warren Buffett to Cathie Wood. No jargon, no right or wrong answers.
      </p>
      <p
        className="font-mono text-xs uppercase tracking-wider mb-8"
        style={{ color: 'hsl(var(--muted-foreground))' }}
      >
        18 questions • ~3 minutes
      </p>

      <Button
        size="lg"
        className="rounded-full px-10"
        onClick={onStart}
      >
        {hasInProgress ? 'Resume Quiz' : 'Start Quiz'}
      </Button>

      {hasInProgress && (
        <button
          onClick={onStartOver}
          className="mt-4 text-sm underline underline-offset-4 hover:opacity-80 transition-opacity"
          style={{ color: 'hsl(var(--muted-foreground))' }}
        >
          Start over
        </button>
      )}
    </div>
  );
};
